<template>
  <div class="content">
    <el-row>
      <el-col :span="6">&nbsp;</el-col>
      <el-col :span="12" class="title_name">
        01
      </el-col>
      <el-col :span="6">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20" class="title">
        <img v-lazy="require('../../assets/imgs/iphone_room_title1.png')" class="iphoneimg" />
      </el-col>
    </el-row>
    <p class="twotitle">以科技之力服务诵与读</p>
    <p class="twotitle" style="margin-bottom:3vh">承中华之文化培育德与智</p>
    <el-row class="one">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_room1.png')" class="iphoneimg" />
      </el-col>
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20" class="one_footer">
          视听说背一体 互动性快乐教室
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20" class="one_footer">
          讲学演示指导 创新型终端课堂
        </el-col>
      </el-row>
    </el-row>
    <el-row>
      <el-col :span="6">&nbsp;</el-col>
      <el-col :span="12" class="title_name">
        02
      </el-col>
      <el-col :span="6">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20" class="title">
        <img v-lazy="require('../../assets/imgs/iphone_room_title2.png')" class="iphoneimg" />
      </el-col>
    </el-row>
    <p class="twotitle" style="margin-bottom:3vh">轻松搞定一堂阅读课 听学结合生动高效</p>
    <el-row class="two">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_room2.png')" class="iphoneimg" />
      </el-col>
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_room3.png')" class="iphoneimg" />
      </el-col>
      <el-col :span="24" class="above">
        <el-col :span="1" class="center">
          <img v-lazy="require('../../assets/imgs/iphone_room_center.png')" class="iphoneimg" />
        </el-col>
        <img v-lazy="require('../../assets/imgs/iphone_room4.png')" class="iphoneimg" />
        <el-col :span="24" class="below">
          <img v-lazy="require('../../assets/imgs/iphone_room_left.png')" class="iphoneimg" />
        </el-col>

      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">&nbsp;</el-col>
      <el-col :span="12" class="title_name">
        03
      </el-col>
      <el-col :span="6">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20" class="title">
        <img v-lazy="require('../../assets/imgs/iphone_room_title3.png')" class="iphoneimg" />
      </el-col>
    </el-row>
    <p class="twotitle" style="margin-bottom:3vh">赋能朗读 视听说一体 教学体验全面提升</p>
    <el-row class="three">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_room5.png')" class="iphoneimg" />
      </el-col>
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_room6.png')" class="iphoneimg" />
      </el-col>
      <el-col :span="24" class="above">
        <el-col :span="1" class="center">
          <img v-lazy="require('../../assets/imgs/iphone_room_center.png')" class="iphoneimg" />
        </el-col>
        <img v-lazy="require('../../assets/imgs/iphone_room7.png')" class="iphoneimg" />
        <el-col :span="24" class="below">
          <img v-lazy="require('../../assets/imgs/iphone_room_right.png')" class="iphoneimg" />
        </el-col>

      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">&nbsp;</el-col>
      <el-col :span="12" class="title_name">
        04
      </el-col>
      <el-col :span="6">&nbsp;</el-col>
    </el-row>
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20" class="title" style="margin-bottom:0vh">
        <img v-lazy="require('../../assets/imgs/iphone_room_title4.png')" class="iphoneimg" />
      </el-col>
    </el-row>
    <el-row class="four">
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/iphone_room8.png')" class="iphoneimg" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "iphoneMsp",
  data () {
    return {

    };
  }
};
</script>
<style scoped>
.title {
  margin-top: 5vh;
  /* height: 2.7vh; */
  margin-bottom: 4vh;
}
.iphoneimg {
  width: 100%;
  height: 100%;
}
.twotitle {
  color: rgb(153, 153, 153);
  margin-bottom: 1vh;
}
.twotitle:last-child {
  margin-bottom: 5vh;
}
.title_name {
  font-size: 50px;
  font-family: DIN;
  font-weight: bold;
  font-style: italic;
  color: #890101;
  opacity: 0.8;
  margin-top: 50px;
}
.one,
.two,
.three,
.four {
  position: relative;
}
.one_footer {
  background: #97342f;
  border-radius: 30px;
  text-align: center;
  color: white;
  font-size: 16px;
  height: 45px;
  margin: 25px 0 0 0;
  line-height: 45px;
}
.below {
  position: absolute;
  z-index: 1;
  top: -6vh;
}
.center {
  position: absolute;
  left: 47.5%;
  z-index: 2;
}
.below:last-child {
  top: -15vh;
}
.above {
  position: relative;
}
.iphoneimg {
  position: relative;
  z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/iphone/room.vue